import { render } from "./StatsView.vue?vue&type=template&id=4a39f5a2&scoped=true"
import script from "./StatsView.vue?vue&type=script&lang=js"
export * from "./StatsView.vue?vue&type=script&lang=js"

import "./StatsView.vue?vue&type=style&index=0&id=4a39f5a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a39f5a2"]])

export default __exports__